module.exports = __webpack_public_path__ + "static/media/football.72b7d44d.svg";